<ul class="links" *ngIf="teste">
  <li *ngFor="let item of [{qual: 'loja', rotulo: 'Loja', icone: 'fa-store', url: teste.loja, acesso: teste.acessos?.loja, verbo: 'Abriu'},
                           {qual: 'painel', rotulo: 'Painel', icone: 'fa-sliders-h', url: teste.painel, acesso: teste.acessos?.painel, verbo: 'Entrou'}]"
      [class.links__item--aberto]="item.acesso">
    <span class="links__icone" aria-hidden="true"><i class="fas" [ngClass]="item.icone"></i></span>
    <div class="links__texto">
      <div class="links__topo">
        <strong>{{ item.rotulo }}</strong>
        <span class="links__acesso" *ngIf="item.acesso as a; else naoAbriu"
              [title]="a.primeiroEm ? 'Primeira vez em ' + (a.primeiroEm | date:'dd/MM HH:mm') : 'Último login na conta (sem clique registrado no link)'">
          <span class="links__ponto" aria-hidden="true"></span>{{ item.verbo }}<ng-container *ngIf="a.acessos > 1"> {{ a.acessos }}×</ng-container> · {{ a.ultimoEm | date:'dd/MM HH:mm' }}
        </span>
        <ng-template #naoAbriu><span class="links__acesso links__acesso--nao">{{ teste.anteriorAoRegistro ? 'Sem registro' : 'Ainda não abriu' }}</span></ng-template>
      </div>
      <ng-container *ngIf="item.url; else semUrl">
        <a *ngIf="item.qual === 'loja'" class="links__url" [href]="item.url" target="_blank" rel="noopener" [title]="item.url">{{ semProtocolo(item.url) }}</a>
        <a *ngIf="item.qual === 'painel'" class="links__url" [href]="linkDaEquipe(item.url)" target="_blank" rel="noopener"
           title="Entra na conta do lead (não conta como acesso dele)">{{ dominio(item.url) }}<span class="links__token">/auth/…</span></a>
      </ng-container>
      <ng-template #semUrl><span class="links__url links__url--texto">Link não gerado</span></ng-template>
    </div>
    <button type="button" class="links__copiar" *ngIf="item.url" (click)="copie(item.qual)"
            [attr.aria-label]="'Copiar link ' + (item.qual === 'loja' ? 'da loja' : 'do painel')"
            [title]="copiado === item.qual ? 'Copiado' : 'Copiar'">
      <i class="fas" [ngClass]="copiado === item.qual ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>
    </button>
  </li>
</ul>
<p class="links__nota" *ngIf="teste?.painel">O link do painel entra direto na conta do lead e vale 7 dias. Aberto por aqui, não conta como acesso dele.</p>
<p class="links__nota" *ngIf="teste?.anteriorAoRegistro">Teste criado antes de 27/09: os cliques nos links não eram registrados, então "Sem registro" não quer dizer que ele não abriu.</p>

<div class="passos" *ngIf="teste?.onboarding as o">
  <div class="passos__topo">
    <strong>{{ o.semPassoAPasso ? 'O que a loja já tem' : 'Primeiros passos no painel' }}</strong>
    <span class="passos__conta num" [class.passos__conta--ok]="o.concluido">
      {{ o.concluido ? 'Concluído' + (o.fase ? ' · ' + o.fase : '') : o.feitos + ' de ' + o.total }}
    </span>
  </div>
  <p class="passos__perfil" *ngIf="o.perfil as pf">
    <span *ngIf="pf.tipoComida"><i class="fas fa-store" aria-hidden="true"></i> {{ pf.tipoComida }}</span>
    <span *ngIf="pf.faturamento"><i class="fas fa-chart-line" aria-hidden="true"></i> Delivery no mês passado: {{ pf.faturamento }}</span>
  </p>
  <div class="passos__barra" role="img" [attr.aria-label]="o.feitos + ' de ' + o.total + ' passos feitos'">
    <span *ngFor="let p of o.passos" [class.feito]="p.feito" [class.iniciado]="!p.feito && p.iniciado"></span>
  </div>
  <ol class="passos__lista">
    <li *ngFor="let p of o.passos" [class.passos__item--feito]="p.feito" [class.passos__item--iniciado]="!p.feito && p.iniciado">
      <span class="passos__icone" aria-hidden="true">
        <i class="fas" [ngClass]="p.feito ? 'fa-check' : (p.iniciado ? 'fa-adjust' : 'fa-circle')"></i>
      </span>
      <span class="passos__texto">
        <span class="passos__nome">{{ p.nome }}</span>
        <small>{{ p.feito || p.iniciado ? p.detalhe : 'Ainda não fez' }}</small>
      </span>
    </li>
  </ol>
  <p class="links__nota" *ngIf="o.semPassoAPasso">Loja anterior ao passo a passo do painel: pagamento, onde recebe os pedidos e o pedido de teste não são acompanhados.</p>
</div>
